import { useMemo, useState } from "react";
import { Link } from "react-router-dom";
import { Gift, PenLine, Share2 } from "lucide-react";
import { SendVerseDialog } from "./SendVerseDialog";
import { MARKS } from "@/lib/deep";
import { VerseCardDialog } from "@/components/cast/VerseCard";
import { NoteDialog } from "./NoteDialog";

export function HighlightItem({ m, abbr, kids, onNote }: { m: any; abbr: string; kids: any[]; onNote: (n: string) => void }) {
  const [note, setNote] = useState(false);
  const [card, setCard] = useState(false);
  const [gift, setGift] = useState(false);
  const id = `${m.book}-${m.ch}-${m.verse}`;
  const verse = useMemo(() => ({ ref: m.ref, text: m.text, version: abbr }), [m.ref, m.text, abbr]);
  return (
    <div className="card-warm flex gap-3 p-4" data-testid={`deep-highlight-${id}`}>
      <span className="mt-1.5 h-3 w-3 shrink-0 rounded-full" style={{ background: MARKS[m.color]?.dot }} />
      <div className="min-w-0 flex-1">
        <Link to={`/deep-dive/${m.book}/${m.ch}`} className="block hover:underline" data-testid={`deep-highlight-link-${id}`}>
          <span className="block text-sm font-semibold text-slate-900">{m.ref}</span>
          <span className="line-clamp-2 font-scripture text-slate-600">{m.text}</span>
        </Link>
        {m.note && <p className="mt-2 rounded-lg bg-amber-50 px-3 py-2 text-sm text-amber-950" data-testid={`deep-highlight-note-${id}`}>{m.note}</p>}
        <div className="mt-2 flex gap-2">
          <button data-testid={`deep-highlight-note-btn-${id}`} onClick={() => setNote(true)} className="flex items-center gap-1 rounded-full px-2 py-1 text-xs font-semibold text-slate-600 hover:bg-slate-100"><PenLine className="h-3.5 w-3.5" />{m.note ? "Edit note" : "Add note"}</button>
          <button data-testid={`deep-highlight-share-${id}`} onClick={() => setCard(true)} className="flex items-center gap-1 rounded-full px-2 py-1 text-xs font-semibold text-slate-600 hover:bg-slate-100"><Share2 className="h-3.5 w-3.5" />Share</button>
          {kids.length > 0 && <button data-testid={`deep-highlight-send-${id}`} onClick={() => setGift(true)} className="flex items-center gap-1 rounded-full px-2 py-1 text-xs font-semibold text-[#E07A5F] hover:bg-rose-50"><Gift className="h-3.5 w-3.5" />Send to Kids Cove</button>}
        </div>
      </div>
      <NoteDialog open={note} onOpenChange={setNote} book={m.book} ch={m.ch} verse={m.verse} refText={m.ref} note={m.note || ""} onSaved={onNote} />
      <VerseCardDialog verse={verse} noteText={m.note} open={card} onOpenChange={setCard} />
      {kids.length > 0 && <SendVerseDialog open={gift} onOpenChange={setGift} kids={kids} book={m.book} ch={m.ch} verses={[m.verse]} refText={m.ref} text={m.text} />}
    </div>
  );
}
